import { get } from 'helpers/apiHelpers';
import types from 'helpers/constants';
import { store } from 'store';

// eslint-disable-next-line consistent-return -- FIXME
export const fetchOrderStatuses = () => dispatch => {
  if (
    !store.getState().OrderStatuses.loading &&
    store.getState().OrderStatuses.orderStatuses.length === 0
  ) {
    dispatch({
      type: types.START_LOADING_ORDER_STATUSES,
    });
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    return get('/order-statuses', { pagination: false }).then(response => {
      dispatch({
        type: types.FETCH_ORDERSTATUSES,
        payload: {
          orderStatuses: response['hydra:member'],
        },
      });
      dispatch({
        type: types.FINISH_LOADING_ORDER_STATUSES,
      });
    });
  }
};
